import { useAuthState } from '@contexts/auth/AuthContext';

// ======================================
// Get the current loggedIn user name
// ======================================
export const useProfileName = () => {
  const { userInfo } = useAuthState();
  const profileName =
    userInfo.firstName && userInfo.lastName
      ? { profileName: userInfo.firstName + ' ' + userInfo.lastName }
      : {};

  return {
    profileName,
    userName: userInfo.userName || '',
    phone: userInfo.phone || '',
  };
};
